import * as ActionType from '../actions/app-view';

const defaultState = 'loading';

/**
 * @description
 * get the setup data required for every page of the app.
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function appView (state = defaultState, action) {

	let newState = {...state};

	switch (action.type) {

		case ActionType.SET_APP_VIEW : {
			newState = action.appView;
			return newState;
		}

		default:
			return state;
	}

}
